import { createVNode as s, mergeProps as n } from "vue";
import o from "../node_modules/@pf-ui/pf-icon-svg/es/asn/MessageOutlinedStandard.js";
import d from "../components/PfIcon.js";
const e = (t, r) => {
  const a = {
    ...t,
    ...r.attrs
  };
  return s(d, n(a, {
    icon: o
  }), null);
};
e.displayName = "MessageOutlinedStandard";
e.inheritAttrs = !1;
export {
  e as default
};
